import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

export default class TooltipLabel extends Component {
	render() {
    const { labelText, tooltipId, placement } = this.props;

		return (
			<div>
      {labelText}&nbsp;
      <OverlayTrigger
        placement={placement || 'right'}
        overlay={
          <Tooltip id={`${tooltipId}-tooltip`} style={{ zIndex: '9999' }}>
            {this.props.children}
          </Tooltip>
        }
      >
        <FontAwesomeIcon icon='question-circle' />
      </OverlayTrigger>
    </div>
		);
	}
}
